import React, { useState } from 'react'
import { Checkbox } from '../../Checkbox'

export function FilterSection({ title, options, selectedOptions, onToggle }) {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <div className={`filter-section ${!isOpen ? '-closed' : ''}`}>
      <div className="filter-section__header" onClick={() => setIsOpen(!isOpen)}>
        <span className='triangle'>
          {isOpen
            ?
            <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 7L1.5359 1L8.4641 1L5 7Z" stroke="white" />
            </svg>
            :
            <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 5L1 8.4641V1.5359L7 5Z" stroke="white" />
            </svg>
          }
        </span>
        <h4 className="filter-section__title">{title}</h4>
      </div>
      
      {isOpen && (
        <div className="filter-section__options">
          {options.map((option) => (
            <Checkbox
              key={option}
              name={option}
              state={selectedOptions.includes(option) ? 1 : -1}
              onChange={() => onToggle(option)}
            />
          ))}
        </div>
      )}
    </div>
  )
}


